import { useUserPreferences } from '@/hooks/useUserPreferences';
import { formatDate, formatTime, formatDateTime } from '@/lib/formatters';

interface FormattedDateProps {
  date: Date | string;
  showTime?: boolean;
  className?: string;
}

export const FormattedDate = ({ date, showTime = false, className }: FormattedDateProps) => {
  const { preferences, loading } = useUserPreferences();

  if (loading) {
    return <span className={className}>...</span>;
  }

  const formatted = showTime 
    ? formatDateTime(date, preferences)
    : formatDate(date, preferences);

  return <span className={className}>{formatted}</span>;
};
